module.exports = __webpack_public_path__ + "img/front-iluminado-light.3770641a.png";